import React from "react";
import styled, { css } from "styled-components";
import { narrowScreenMediaQuery } from "../constants/styles";
import { bg_3_src } from "../images/index";
import Header from "../commons/Header";
import Footer from "../commons/Footer";
import Content from "./Content";
import { unmodule } from "../util";

const UnnamedComponent = () => {
  const bgType = "video";
  // const bgType = "image";

  React.useLayoutEffect(() => {
    // Disable browser scroll restoration
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    // Scroll to top immediately (before paint)
    window.scrollTo(0, 0);
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    if (document.body) {
      document.body.scrollTop = 0;
    }
  }, []);

  React.useEffect(() => {
    // Also scroll after render to handle any async content loading
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      }
      if (document.body) {
        document.body.scrollTop = 0;
      }
    };

    scrollToTop();
    // Small delay to catch any late-rendering content
    const timeoutId = setTimeout(scrollToTop, 100);

    return () => clearTimeout(timeoutId);
  }, []);

  let ret;
  ret = (
    <React.Fragment>
      {bgType === "video" ? (
        <React.Fragment>
          <BackgroundVideo
            autoPlay
            loop
            muted
            playsInline
            preload="none"
            $shownOnNarrowScreenOnly
          >
            <source
              type="video/mp4"
              src="https://taxsam.co/wp-content/uploads/2024/12/mixkit-sunrise-behind-the-buildings-of-frankfurt-30468-hd-ready.mp4"
            />
          </BackgroundVideo>
          <BackgroundVideo
            autoPlay
            loop
            muted
            playsInline
            preload="none"
            $shownOnWiderScreenOnly
          >
            <source
              type="video/mp4"
              src={unmodule(require("../images/bg-vid-crop.mp4"))}
            />
          </BackgroundVideo>
          <BackgroundOverlay />
          <Header $transparent />
        </React.Fragment>
      ) : (
        bgType === "image" && (
          <React.Fragment>
            <BackgroundImage $src={bg_3_src} />
            <Header $transparent />
          </React.Fragment>
        )
      )}
      <Content />
      <Footer />
    </React.Fragment>
  );

  return ret;
};
export default UnnamedComponent;

// const BackgroundIframe = styled.iframe`
// --offset: 150px;
// position: fixed;
// z-index: -1;
// top: calc(var(--offset) * -1);
// left: calc(var(--offset) * -1);
// width: calc(100% + var(--offset));
// height: calc(100% + var(--offset));

// @media ${narrowScreenMediaQuery} {
// display: none;
// }
// `;

const BackgroundVideo = styled.video`
  display: block;
  height: 100%;
  left: 0;
  object-fit: none;
  object-position: top;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: -2;

  ${(props) =>
    props.$shownOnNarrowScreenOnly &&
    css`
      display: none;

      @media ${narrowScreenMediaQuery} {
        display: block;
      }
    `};

  ${(props) =>
    props.$shownOnWiderScreenOnly &&
    css`
      @media ${narrowScreenMediaQuery} {
        display: none;
      }
    `};
`;

const BackgroundOverlay = styled.div`
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: -1;
  background-color: transparent;
  background-image: linear-gradient(210deg, #04000c80 51%, #524739 92%);
  opacity: 1;
  transition:
    background 0.3s,
    border-radius 0.3s,
    opacity 0.3s;

  ${(props) =>
    props.$fixed &&
    css`
      position: fixed;
    `};
`;

const BackgroundImage = styled.div`
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;

  ${(props) =>
    props.$src &&
    css`
      background-image: url(${props.$src});
    `};
`;
